import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {
  TextInputComponent,
  TextModes,
} from '../../ui/controls/text-input/text-input.component';
import { DdlInputComponent } from '../../ui/controls/ddl-input/ddl-input.component';
import { AccountService } from '../../../models/account/accountService';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import {
  FormValidator,
  ValidationMessage,
} from '../../../models/validation/formValidator';
import { iValidatedControl } from '../../ui/controls/iValidatedControl';
import { UIHelpers } from '../../../core/ui-helpers';
import { Account } from '../../../models/account/account';
import { FormMode } from '../../../core/constants';
import { BaseComponent } from '../../baseComponent';

@Component({
  selector: 'app-account-info-form',
  templateUrl: './account-info-form.component.html',
  standalone: false,
})
export class AccountInfoFormComponent extends BaseComponent {
  @Input() headerText: string = 'Account Information';
  @Input() account: Partial<Account> = Account.createEmpty();
  @Input() accountId: string = '';
  @Input() enableEditing: boolean = false;
  @Input() mode: FormMode = FormMode.View;
  @Input() enableDataStore: boolean = false;
  @Output() saved = new EventEmitter<boolean>();

  @ViewChildren(TextInputComponent) validatedTextBoxes:
    | QueryList<TextInputComponent>
    | undefined;
  @ViewChildren(DdlInputComponent) validatedDropDowns:
    | QueryList<DdlInputComponent>
    | undefined;

  data: Partial<Account> = Account.createEmpty();

  inputTextModes = TextModes;

  constructor(
    public accountService: AccountService,
    private uiErrorHandler: UIErrorHandler,
    private formValidator: FormValidator,
  ) {
    super();
  }

  ngOnInit() {
    this.copyModelData(this.account, this.data);

    //if (!this.merchantId || this.merchantId == "") {
    //  throw "[merchantId] required on merchant-contact component"
    //}
  }

  public validate(): ValidationMessage[] {
    let errors: ValidationMessage[] = [];

    let validatedControls: iValidatedControl[] = [];
    if (this.validatedTextBoxes && this.validatedDropDowns) {
      validatedControls = validatedControls.concat(
        this.validatedTextBoxes.toArray(),
      );
      validatedControls = validatedControls.concat(
        this.validatedDropDowns.toArray(),
      );

      errors = this.formValidator.validate(validatedControls);
    }

    return errors;
  }

  public getData(): Partial<Account> {
    return this.data;
  }

  private copyModelData(
    source: Partial<Account>,
    destination: Partial<Account>,
  ) {
    destination.accountName = source.accountName;
    destination.id = source.id;
    destination.owner = {};
    destination.owner.emailAddress = source.owner?.emailAddress;
    destination.owner.firstName = source.owner?.firstName;
    destination.owner.lastName = source.owner?.lastName;
    destination.owner.phone = source.owner?.phone;
    destination.owner.fax = source.owner?.fax;
  }

  btnEdit_click() {
    this.copyModelData(this.account, this.data);

    this.mode = FormMode.Edit;
  }

  btnSave_click() {
    var that = this;

    this.accountService
      .patchAccountInfo(this.data)
      .then((savedPerson) => {
        //that.copyModelData(savedPerson, that.data);
        that.copyModelData(that.data, that.account);

        that.saved.emit(true);
        that.mode = FormMode.View;
        UIHelpers.scrollToTop('contactInformationContainer');
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  btnCancel_click() {
    this.copyModelData(this.account, this.data);

    this.mode = FormMode.View;
    UIHelpers.scrollToTop('contactInformationContainer');
    this.saved.emit(false);
  }
}
